import MedicalDictionaryModal from "./medicalDictionaryModal"

export default MedicalDictionaryModal
